import React, { useState } from 'react'
import SadasyaSikshyaImg1 from '../../Images/SocialService/SadashyaSikshya/1.jpg'
import SadasyaSikshyaImg2 from '../../Images/SocialService/SadashyaSikshya/10.jpg'
import SadasyaSikshyaImg3 from '../../Images/SocialService/SadashyaSikshya/12.jpg'
import SadasyaSikshyaImg4 from '../../Images/SocialService/SadashyaSikshya/13.jpg'
import SadasyaSikshyaImg5 from '../../Images/SocialService/SadashyaSikshya/17.jpg'
import SadasyaSikshyaImg8 from '../../Images/SocialService/SadashyaSikshya/5.jpg'
import SadasyaSikshyaImg9 from '../../Images/SocialService/SadashyaSikshya/6.jpg'
import SadasyaSikshyaImg10 from '../../Images/SocialService/SadashyaSikshya/7.jpg'
import SadasyaSikshyaImg11 from '../../Images/SocialService/SadashyaSikshya/9.jpg'

const SadasyaSikshya = () => {

    const [isModalOpen, setIsModalOpen] = useState(false);
    const [currentImage, setCurrentImage] = useState('');

    const imageList = [
        {
            id: 1,
            image: SadasyaSikshyaImg1
        },
        {
            id: 2,
            image: SadasyaSikshyaImg2
        },
        {
            id: 3,
            image: SadasyaSikshyaImg3
        },
        {
            id: 4,
            image: SadasyaSikshyaImg4
        },
        {
            id: 5,
            image: SadasyaSikshyaImg5
        },
        {
            id: 6,
            image: SadasyaSikshyaImg8
        },
        {
            id: 7,
            image: SadasyaSikshyaImg9
        },
        {
            id: 8,
            image: SadasyaSikshyaImg10
        },
        {
            id: 9,
            image: SadasyaSikshyaImg11
        },
    ]

    const handleImageClick = (image) => {
        setCurrentImage(image);
        setIsModalOpen(true);
    }

    const closeModal = () => {
        setIsModalOpen(false);
        setCurrentImage('');
    }

    return (
        <>
            <div className='main'>
                <div className='left-fixed'></div>
                <div className='container'>
                    <div className='branches-div'>
                        <div className='branches-body'>
                            <div className='card-container'>
                                {imageList.map((item, id) => {
                                    return (
                                        <div className='card' key={id}>
                                            <div className='inner'>
                                                <div className='img-holder' onClick={() => handleImageClick(item.image)}>
                                                    <img src={item.image} alt='gallery-Image' />
                                                </div>
                                                {/* <div className='detail'>
                                                    <h3>{item.galleryName}</h3>
                                                </div> */}
                                            </div>
                                        </div>
                                    )
                                })}
                            </div>
                        </div>
                    </div>
                </div>
                <div className='right-fixed'></div>

                {isModalOpen && (
                    <div className='modal'>
                        <span className='close' onClick={closeModal}>&times;</span>
                        <img className='modal-content' src={currentImage} alt='fullscreen' />
                    </div>
                )}
            </div>
        </>
    )
}

export default SadasyaSikshya